export default __webpack_public_path__ + "static/media/eb-pro-wht-banner-1.f850dc06.jpg";